import { AdminLayout } from '@/modules/shared';
import { useAuthStore } from '@/stores/auth';

// Route configuration for agency section
const agencyRoutes = [
  {
    path: '/agency',
    component: AdminLayout,
    meta: { requiresAuth: true, requiresAgency: true },
    beforeEnter: (to, from, next) => {
      const authStore = useAuthStore();
      
      // Verifica se o usuário é uma agência
      if (authStore.isAuthenticated && authStore.user?.userType === 'agency') {
        next();
      } else {
        // Redireciona para a página principal de acordo com o tipo de usuário
        if (authStore.isAdmin) {
          next('/admin/dashboard');
        } else if (authStore.user?.companyId) {
          next('/clients/dashboard');
        } else {
          next('/login');
        }
      }
    },
    children: [
      // {
      //   path: '',
      //   name: 'agency-list',
      //   component: () => import('@/modules/agency-portal/views/AgencyList.vue')
      // },
      // {
      //   path: 'dashboard',
      //   name: 'agency-dashboard',
      //   component: () => import('@/modules/agency-portal/views/AgencyDashboard.vue')
      // },
      // Licenças
      {
        path: 'licenses',
        name: 'agency-licenses',
        component: () => import('@/modules/agency-portal/views/LicenseList.vue')
      },
      {
        path: 'licenses/activate',
        name: 'agency-license-activate',
        component: () => import('@/modules/agency-portal/views/LicenseActivationForm.vue')
      },
      // {
      //   path: 'licenses/:id',
      //   name: 'agency-license-detail',
      //   component: () => import('@/modules/agency-portal/views/LicenseDetail.vue'),
      //   props: true
      // },
      // Clientes
      // {
      //   path: 'clients',
      //   name: 'agency-clients',
      //   component: () => import('@/modules/agency-portal/views/ClientList.vue')
      // },
      // {
      //   path: 'clients/:id',
      //   name: 'agency-client-detail',
      //   component: () => import('@/modules/agency-portal/views/ClientDetail.vue'),
      //   props: true
      // },
      // NOVA ROTA - feito por claude code
      // Empresas Conectadas
      {
        path: 'connected-companies',
        name: 'agency-connected-companies',
        component: () => import('@/modules/agency-portal/views/ConnectedCompanyList.vue')
      },
      // NOVA ROTA - feito por Claude Code - Rota para listagem de empresas gerenciadas pela agência
      {
        path: 'managed-companies',
        name: 'agency-managed-companies',
        component: () => import('@/modules/agency-portal/views/ManagedCompaniesPage.vue')
      },
      // NOVA ROTA - Sistema de Abas para gerenciamento de empresas
      {
        path: 'companies/:companyId/manage',
        name: 'agency-company-manage',
        component: () => import('@/modules/agency-portal/views/AgencyCompanyManagePage.vue'),
        props: true
      },
      // Compras
      // {
      //   path: 'purchases',
      //   name: 'agency-purchases',
      //   component: () => import('@/modules/agency-portal/views/PurchaseList.vue')
      // },
      // {
      //   path: 'purchases/new',
      //   name: 'agency-purchase-new',
      //   component: () => import('@/modules/agency-portal/views/PurchaseForm.vue')
      // },
      // {
      //   path: 'purchases/:id',
      //   name: 'agency-purchase-detail',
      //   component: () => import('@/modules/agency-portal/views/PurchaseDetail.vue'),
      //   props: true
      // },
      // Perfil da Agência
      // {
      //   path: 'profile',
      //   name: 'agency-profile',
      //   component: () => import('@/modules/agency-portal/views/AgencyProfile.vue')
      // }
    ]
  }
];

export default agencyRoutes;